// Push notification utilities for browser notifications
const NOTIFICATION_PERMISSION_KEY = 'notification_permission_asked';

export const checkNotificationSupport = () => {
  return 'Notification' in window;
};

export const requestNotificationPermission = async () => {
  if (!checkNotificationSupport()) {
    console.log('Browser does not support notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    localStorage.setItem(NOTIFICATION_PERMISSION_KEY, 'true');
    return permission === 'granted';
  }

  return false;
};

export const sendBrowserNotification = (title, options = {}) => {
  if (!checkNotificationSupport() || Notification.permission !== 'granted') {
    return null;
  }

  const defaultOptions = {
    icon: '/favicon.ico',
    badge: '/favicon.ico',
    vibrate: [200, 100, 200],
    requireInteraction: false,
    ...options
  };

  try {
    const notification = new Notification(title, defaultOptions);
    
    notification.onclick = () => {
      window.focus();
      notification.close();
      if (options.onClick) {
        options.onClick();
      }
    };

    // Auto close after 5 seconds
    setTimeout(() => notification.close(), 5000);

    return notification;
  } catch (error) {
    console.error('Error sending notification:', error);
    return null;
  }
};

export const notifyClockEvent = (employeeName, eventType) => {
  const isClockIn = eventType === 'clock_in';
  const title = isClockIn ? '🟢 Employee Clocked In' : '🔴 Employee Clocked Out';
  const body = `${employeeName} has ${isClockIn ? 'started' : 'ended'} their shift`;

  return sendBrowserNotification(title, {
    body,
    tag: `clock-${Date.now()}`, // Unique tag to allow multiple notifications
    requireInteraction: true
  });
};
